import { render, staticRenderFns } from "./etablissement-detail-restauration.vue?vue&type=template&id=06e4d25a&scoped=true"
import script from "./etablissement-detail-restauration.vue?vue&type=script&setup=true&lang=js"
export * from "./etablissement-detail-restauration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./etablissement-detail-restauration.vue?vue&type=style&index=0&id=06e4d25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4d25a",
  null
  
)

export default component.exports